import { render, staticRenderFns } from "./NewsroomList.vue?vue&type=template&id=7d31e5b2&"
import script from "./NewsroomList.vue?vue&type=script&lang=js&"
export * from "./NewsroomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports